module.exports = __webpack_public_path__ + "static/img/1.31986ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/forth/1.jpg
// module id = F/dz
// module chunks = 0